import styled, { css } from 'styled-components';
import { smBold, smLight, smRegular } from '../theme/typography';
import { themeColor } from '../theme/colors';

import { HudIcon } from '../Icons/HudIcons';

export const Container = styled.div<{
  $hasContent?: boolean;
  $inline?: boolean;
}>`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  border-radius: 8px;

  ${(props) =>
    props.theme.name === 'dark' &&
    css`
      box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.04);
    `}
`;

export const InputElement = styled.input`
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
`;

export const Icon = styled(HudIcon)`
  color: ${themeColor('textTertiary')};
`;

const Default = styled(Container)`
  border: 1px solid ${themeColor('strokePrimary')};
  background: ${themeColor('buttonBackground')};

  &:hover,
  &:focus-within {
    background: ${themeColor('buttonBackgroundHover')};
  }

  & ${InputElement} {
    ${smRegular}
    color: ${themeColor('textPrimary')};

    &::placeholder {
      ${smLight}
      color: ${themeColor('textTertiary')};
    }
  }
`;

const Fancy = styled(Container)`
  padding: 18px 12px;

  border: 1px solid transparent;
  background: ${themeColor('buttonBackground')};

  &:hover,
  &:focus-within {
    border: 1px solid ${themeColor('turquoise')};
  }

  & ${InputElement} {
    ${smBold}
    color: ${themeColor('textPrimary')};

    &::placeholder {
      ${smLight}
      color: ${themeColor('textTertiary')};
    }
  }
`;

export const InputVariants = {
  default: Default,
  fancy: Fancy,
};
